import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Modal } from './modules';
//import registerServiceWorker from './registerServiceWorker';

// set global variables
global.__APP_NAME__ = 'Kids UP for Parents';
// make sure that we use prod in production
global.__APP_MODE__
  = (
  process.env.NODE_ENV === 'development'
    ? 'local'
    : (
      window.location.hostname.startsWith('dev')
      || window.location.hostname.includes('firebaseapp')
        ? 'dev'
        : 'prod'
    ));

Modal.setAppElement('#root');

ReactDOM.render(<App/>, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js